module.exports = __webpack_public_path__ + "img/shoppub_logo_v2.1c6e743d.svg";